module.exports = __webpack_public_path__ + "img/venue-25.6bc3cb48.png";